import navigation from './navigation/index';

export default {
  navigation
}



// WEBPACK FOOTER //
// ./src/locales/no/layout/index.js